import { useState } from 'react';
import { apiURL } from '../../consts/URLs';
import { CONDITIONS } from '../endpointList';
import { fetchRequest, getOptions } from '../utils';
import { getCookie } from '../../utils/handleCookie';
import { cookieName } from '../../consts/cookie';

export interface Category {
    name: string;
    ordering: string;
}

const token = getCookie(cookieName.token);

const useConditions = () => {
    const [getConditionsResponse, setGetConditionsResponse] = useState<any>();
    const [getConditionsResult, setGetConditionsResult] = useState<any>();

    const [createConditionsResponse, createGetConditionsResponse] = useState<any>();
    const [createConditionsResult, createGetConditionsResult] = useState<any>();

    const [deleteConditionsResponse, setDeleteConditionsResponse] = useState<any>();
    const [deleteConditionsResult, setDeleteConditionsResult] = useState<any>();

    const [updateConditionsResponse, setUpdateConditionsResponse] = useState<any>();
    const [updateConditionsResult, setUpdateConditionsResult] = useState<any>();

    const getConditions = () => {
        const url = `${apiURL}/${CONDITIONS}`;
        const options = getOptions({ method: 'GET', token: token });
        fetchRequest(url, options, setGetConditionsResponse, setGetConditionsResult);
    };

    const createCondition = (obj: any) => {
        const url = `${apiURL}/${CONDITIONS}?name=${encodeURI(obj.name)}&notes=${obj.notes}`;
        const options = getOptions({ method: 'POST', token: token });
        fetchRequest(url, options, createGetConditionsResponse, createGetConditionsResult);
    };

    const deleteCondition = (id: number) => {
        const url = `${apiURL}/${CONDITIONS}/${id}/delete`;
        const options = getOptions({ method: 'DELETE', token: token });
        fetchRequest(url, options, setDeleteConditionsResponse, setDeleteConditionsResult);
    };

    const updateCondition = (obj: any) => {
        const url = `${apiURL}/${CONDITIONS}/${obj.id}?name=${encodeURI(obj.name)}`;
        const options = getOptions({ method: 'PUT', token: token });
        fetchRequest(url, options, setUpdateConditionsResponse, setUpdateConditionsResult);
    };

    const RESPONSES = {
        getConditionsResponse,
        createConditionsResponse,
        deleteConditionsResponse,
        updateConditionsResponse,
    };

    const RESULTS = {
        getConditionsResult,
        createConditionsResult,
        deleteConditionsResult,
        updateConditionsResult,
    };

    const CTAs = {
        getConditions,
        createCondition,
        deleteCondition,
        updateCondition,
    };

    return { RESPONSES, RESULTS, CTAs };
};
export default useConditions;
